import { AddSchema } from '../../schemas/addSchema'
import { Variables } from './api/types'

export const mapper = (data: AddSchema): Variables => {
  const { divId, domainId, name, outOfPage, outOfPageType, pageIds, path } = data

  return {
    divId: divId || null,
    domainId,
    name: name || null,
    outOfPage,
    outOfPageType,
    pageIds,
    path: path.toLowerCase(),
  }
}
